let i18next;
let VueI18Next;
let vueI18nextInstance;

/**
 * Exposes i18next's translation capabilities to non-Vue code
 * @param key
 * @param options
 * @returns {string}
 */
export function translate (key, options) {
  if (!I18nService.isInitialized) {
    throw new Error('i18n is not initialized');
  }
  const defaultOptions = {ns: 'webviewer'};
  options = Object.assign(defaultOptions, options);

  return i18next.t(key, options);
}

export function translateDate (date, options) {
  if (!I18nService.isInitialized) {
    throw new Error('i18n is not initialized');
  }
  const { language } = i18next;

  if (!(date instanceof Date)) {
    date = new Date(date);
  }

  return new Intl.DateTimeFormat(language, options).format(date);
}

/**
 * Generates a helper function that auto-prefixes all `translate` requests
 * usage:
 *     // Assume i18n contains: { some: { key: { prefix: { 'my-value': 'toasty' } } } }
 *     import {translate} from 'shared/services/I18nService';
 *     const $t = translate.scope('some.key.prefix');
 *     const someText = $t('my-value'); // -> 'toasty'
 */
translate.scope = function (keyPrefix) {
  return (key, options) => translate(`${keyPrefix}.${key}`, options);
};

/**
 * Exposes vue-i18next to Vue code
 * @returns {vueI18nextInstance} initialized instance of VueI18Next
 */
export function getVueI18n () {
  if (!vueI18nextInstance) {
    throw new Error('i18n is not initialized');
  }
  return vueI18nextInstance;
}

export class I18nService {
  /**
   * This service simply installs the i18n and vue-i18n as a read-only property on the Vue prototype., which will then
   * be accessible to all components through the service locator.
   */
  static get isInitialized () {
    return vueI18nextInstance && i18next ? i18next.isInitialized : false;
  }

  static install (Vue, options) {
    i18next = options.i18next;
    VueI18Next = options.VueI18Next;

    Vue.use(VueI18Next);

    vueI18nextInstance = new VueI18Next(i18next);
  }
}

// FOR TESTING ONLY (need to rethink this design...)
export function clearDependencies () {
  i18next = VueI18Next = vueI18nextInstance = null;
}
